import "../../../../assets/MeritPage/scss/MeritPage.scss";
import React, {
  useRef,
  useState,
  useContext,
  useReducer,
  useEffect,
} from "react";
import Complaints from "../Common/Complaints";
import TC from "../../../../assets/pdf/TOBA_New.pdf";
import MeritDataList_RF_V1 from "./MeritDataList_RF_V1";
import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { getPageName } from "../../../../Constants/PageNames";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";


const MeritPopup_RF_V1_FLP = ({
  meritPagePopUp,
  popUpModalBody,
  meritPopUpLoader,
  meritPopUpContent,
  combinedMeritPageData,
  handleMeritPopUp,
  customUuid,
  allFollowupData,
  splitName,
  queryString,
}) => {
  const cfirstName = localStorage.getItem("UcFname")
    ? localStorage.getItem("UcFname")
    : "";
  const [showModal, setShowModal] = useState(0);
  const [showComplaint, setShowComplaint] = useState(false);
  const { savePageLoad, calledOnce } = usePageLoad();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const uuid = customUuid || visitorParameters?.data?.uuid || "";
  useEffect(() => {
    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("merit_page"),
        status: "visited",
        source: allFollowupData.atp_sub6,
      };
      (async () => {
        await savePageLoad(
          uuid,
          data,
          "visited_status",
          splitName,
          queryString,
          visitorParameters.data
        );
      })();
    }
  }, [uuid, calledOnce]);
  const modalClick = (clickValue) => {
    switch (clickValue) {
      case "showComplaint": {
        setShowComplaint(true);
        break;
      }
      case "exitComplaint": {
        setShowComplaint(false);
        break;
      }
    }
  };

  return (
    <div className="MeritPage">
      <div
        className={`modal blackover fade ${meritPagePopUp ? "show" : "hide"}`}
        id="sample"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div
            className={`modal-content  goodnews_popup ${popUpModalBody == "show" ? "show" : "hide"
              }`}
          >
            <div className="modal-body">
              <div
                className={`text-center max-400 m-auto thakyoumsg ${meritPopUpLoader == "show" ? "show" : "hide"
                  }`}
              >
                <div className="pb-lg-2 mt-5 ">
                  <img height="50" src="assets/MeritPage/img/logo.png" alt="" />
                </div>
                <div className="my-4 mt-5">
                  <img
                    height="50"
                    src="assets/MeritPage/img/loader-review2.svg"
                    alt=""
                  />
                </div>
                <div className="">
                  <h4 className="h4-thakyou">
                    Thank you <strong>{cfirstName}</strong> for completing our
                    assessment, which we will output into a questionnaire
                    format.
                  </h4>
                  <h5 className="fst-italic fs-6">
                    {" "}
                    Please note – you are able to self represent your complaint.
                  </h5>
                </div>
              </div>

              <div
                className={`goodnewsrow ${meritPopUpContent == "show" ? "show" : "hide"
                  }`}
              >
                <div className="pb-3 text-center px-lg-4 px-md-4  px-sm-0">
                  <div className="title mb-2">
                    {" "}
                    <strong className="textgood text-success">
                      GOOD NEWS,
                    </strong>{" "}
                  </div>
                  <h4>
                    From your responses, we understand that you were using your
                    overdraft for a prolonged period and not just for a
                    short-term emergency and were not able to clear it in a
                    reasonable period of time. We therefore believe your case
                    has merit because you told us:
                  </h4>
                  <div className="d-flex justify-content-center  ">
                    <ul className="p-0 m-0 mt-2  text-start row  justify-content-center listfi ">
                      <li className="align-items-center">
                        <a onClick={() => setShowModal(1)}>
                          Not using your overdraft for just a short-term
                          emergency
                        </a>
                      </li>

                      <li className="align-items-center">
                        <a onClick={() => setShowModal(2)}>
                          Could not clear the overdraft in a reasonable period
                          of time.
                        </a>
                      </li>

                      <li className="align-items-center">
                        <a onClick={() => setShowModal(3)}>
                          Not maintained a positive balance for a significant
                          period of time
                        </a>
                      </li>
                    </ul>
                  </div>

                  <p className="mt-4 p-align">
                    1. Please note that you have the right to pursue a complaint
                    directly with your lender and thereafter directly to the
                    Financial Ombudsman Service for free and without using the
                    firm or any solicitor or claims handler.
                  </p>
                  <p className="p-align">
                    2. We operate on a ‘No Win No Fee’ basis. Our fees range
                    from 18% to 36% including VAT, which is dependent on the
                    amount of redress awarded. Please{" "}
                    <a className="text-primary" href={TC} target="_blank">
                      click here
                    </a>{" "}
                    for further details.
                  </p>
                  <p className="p-align">
                    3. The lender may reduce the credit limit/ suspend the card
                    or remove/ close the product (credit card/ overdraft cases)
                    or may repossess the car (car loan cases) you acknowledge
                    that by making the unaffordable/ irresponsible lending
                    complaint that you may not be able to borrow from the lender
                    in future.
                  </p>
                  <p className="p-align">
                    4. If you decide to sign up with the firm the next steps are
                    that the firm will assess the paperwork, initiate a
                    background check, carry out the onboarding process, then if
                    this all proceeds successfully the firm will send its advice
                    on the merits and, if merits are reasonable or more than
                    reasonable, the firm will process your claim and send it to
                    the lender. Should the claim to the lender be rejected and
                    the firm see merit in it, or should the lender not respond
                    in time and the firm see merit in doing so, the firm will
                    send it to the Financial Ombudsman Service and will inform
                    you of that decision at that time.
                  </p>

                  <div className="mt-4 mb-3">
                    <h5 className="text-arrow text-black">
                      <strong>
                        {" "}
                        I understand the merits of my claim and have read and
                        understood the above guidance. To instruct TMS Legal to
                        pursue your claim, Click the button below.{" "}
                      </strong>
                    </h5>
                  </div>

                  <div className="mb-3">
                    <button
                      id="proceedBtn"
                      className=" btn-comm2 p-2    py-3 px-4 pulse"
                      onClick={handleMeritPopUp}
                    >
                      <span>Proceed with my claim</span>
                    </button>
                  </div>
                  <p className="fst-italic p-align">
                    There are however many benefits of choosing us to handle
                    your claim. We will manage all communication with your
                    lender, working closely with them to ensure that you receive
                    a fair level of compensation. If your lender encounters any
                    difficulties in locating your details, we will assist them
                    to enable your claim to proceed. After you register with us,
                    you can simply sit back and relax while we handle
                    everything, keeping you updated via email throughout the
                    process.
                  </p>
                </div>
              </div>

              <MeritDataList_RF_V1
                category={showModal}
                InputValues={combinedMeritPageData}
                setShowModal={setShowModal}
              />

              <Complaints
                showComplaint={showComplaint}
                modalClick={modalClick}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeritPopup_RF_V1_FLP;
